import { Fragment } from "react";
import { Grid, useMediaQuery } from "@mui/material";

import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { StyledEmptyWrapper, StyledPagination } from "@framework/styled";
import { IToken, ModuleType, TokenType } from "@framework/types";
import { useFetchQuery } from "@dzambalaorg/react-hooks";
import { IPaginationResult } from "@dzambalaorg/types-collection";

import { TokenSearchForm } from "../../../../../components/forms/token-search";
import { LootTokenListItem } from "./item";

export interface ILootTokenListProps {
  embedded?: boolean;
}

export const LootTokenList = (props: ILootTokenListProps) => {
  const { embedded } = props;

  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount } = useFetchQuery<
    IPaginationResult<IToken>
  >("/loot/tokens", { enableInfiniteScroll: isMd });

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "loot", "loot.tokens"]} isHidden={embedded} />

      <PageHeader message="pages.loot.tokens.title" />

      <TokenSearchForm contractType={[TokenType.ERC721]} contractModule={[ModuleType.LOOT]} />

      <ProgressOverlay isLoading={isLoading}>
        <Grid container spacing={2}>
          <StyledEmptyWrapper count={allRows.length} isLoading={isLoading}>
            {allRows.map(token => (
              <Grid size={{ lg: 4, sm: 6, xs: 12 }} key={token.id}>
                <LootTokenListItem token={token} />
              </Grid>
            ))}
          </StyledEmptyWrapper>
        </Grid>
      </ProgressOverlay>

      {!isMd && totalCount > take && (
        <StyledPagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}
    </Fragment>
  );
};
